<mat-icon class="icon">{{ currentBadge.icon }}</mat-icon>
<span>{{ currentBadge.label }}</span>
